<template>
  <div class="check">
    <el-card class="box-card" style="font-size:20px">
      <div class="hotel-main-title">
        <span class="title-name">公共娱乐场所治安管理系统账号注册</span>
      </div>
    </el-card>

    <div class="main overview">
      <el-row type="flex">
        <img src="@/assets/img/tag.png" alt="" />
        <span class="title_a">基本信息</span>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :xs="24" :sm="24" :md="24" :lg="12">  -->
        <!-- 
            19991654007
            91350206MA348NRD0M
            610525199401160056

           -->
        <el-form
          :model="changeInfo"
          ref="changeInfo"
          :rules="rules"
          class="changeInfo"
          style="background:#fff;padding:50px 0px -50px 15%;"
          label-width="210px"
        >
          <el-col :xs="24" :sm="24" :md="20" :lg="12">
            <el-form-item label="手机号:" prop="username">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input
                  v-model="changeInfo.username"
                  @keyup.enter.native="handlePhone"
                >
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="密码:" prop="userpw">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input
                  type="password"
                  v-model="changeInfo.userpw"
                  autocomplete="new-password"
                  :readonly="readonly"
                  @blur="readonly = true"
                  @click.native="handleClick"
                  @input="handleInput"
                >
                  <!--  autocomplete="new-password"
                  :readonly="readonly"
                  @blur="readonly = true"
                  @click.native="readonly = false" -->
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="验证码:" prop="infoCode">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" class="code_div">
                <el-input
                  class="infoCode"
                  v-model="changeInfo.infoCode"
                  placeholder="请输入验证码"
                >
                </el-input>
                <button
                  @click.prevent="getCode()"
                  class="code-btn"
                  :disabled="!show"
                >
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">{{ count }} s</span>
                </button>
              </el-col>
            </el-form-item>

            <el-form-item label="经营状态:" prop="cs_jyztdm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  v-model="changeInfo.cs_jyztdm"
                  placeholder=""
                  style="width:100%"
                >
                  <el-option
                    v-for="item in jyztData"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="场所名称:" prop="csmc">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.csmc"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="场所编码:" prop="cs_dmsn">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.cs_dmsn"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="场所联系电话:" prop="cs_lxdh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.cs_lxdh"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="经营面积:" prop="jymj">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.jymj">
                  <i slot="suffix" class="zzdw">㎡</i>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="核定消费者数:" prop="hdxfzrs">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.hdxfzrs">
                  <i slot="suffix" class="zzdw">人 </i>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="包厢数量:" prop="bxsl">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.bxsl">
                  <i slot="suffix" class="zzdw">间 </i>
                </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="消防等级:" prop="xfdj">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  v-model="changeInfo.xfdj"
                  placeholder=""
                  style="width:100%"
                >
                  <el-option
                    v-for="item in xfdjData"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label='单位性质:' prop='dwxz'>
              <el-col :xs='24' :sm='24' :md='24' :lg='24'>
                <el-select v-model='changeInfo.dwxz' placeholder='' style='width:100%'>
                  <el-option v-for='item in dwxzData' :key='item.code' :label='item.title' :value='item.code'>
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item> -->
            <el-form-item label="单位类别:" prop="dwlb">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  v-model="changeInfo.dwlb"
                  placeholder=""
                  style="width:100%"
                >
                  <el-option
                    v-for="item in dwlbData"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item
              label="管辖机构:"
              prop="zagldwbm"
            >
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-cascader
                  ref="refHandle"
                  v-model="changeInfo.zagldwbm"
                  :options="xzqh2List"
                  clearable
                  filterable
                  :show-all-levels="false"
                  :props="defaultParams"
                  style="width:100%"
                  @change="isXAChange"
                >
                </el-cascader>
              </el-col>
            </el-form-item>
            <el-form-item label="是否填写标准地址:" prop="is_ybss">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-radio v-model="changeInfo.is_ybss" :label="1">是</el-radio>
                <el-radio v-model="changeInfo.is_ybss" :label="2">否</el-radio>
              </el-col>
            </el-form-item>
            <el-form-item label="企业地址:" prop="pgs">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" class="code_div">
                <el-input
                  :disabled="changeInfo.is_ybss == 1"
                  placeholder=""
                  v-model.trim="changeInfo.pgs"
                >
                  <el-button
                    slot="prepend"
                    :icon="
                      changeInfo.is_ybss == 1
                        ? 'el-icon-edit'
                        : 'el-icon-search'
                    "
                    @click.prevent="handlPgs()"
                    >{{
                      changeInfo.is_ybss == 1 ? '点击填写' : '点击地图选址'
                    }}</el-button
                  >
                </el-input>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label='企业地址:' prop='pgs'>
              <el-col :xs='24' :sm='24' :md='24' :lg='24' class='code_div'>
                <el-input :disabled="changeInfo.zagldwbm == '610100000000'" placeholder='' v-model.trim='changeInfo.pgs'>
                  <el-button slot="prepend"
                    :icon="changeInfo.zagldwbm == '610100000000' ? 'el-icon-edit' : 'el-icon-search'"
                    @click.prevent='handlPgs()'>{{
                      changeInfo.zagldwbm == '610100000000' ? '点击填写' : '点击地图选址'
                    }}</el-button>
                </el-input>
              </el-col>
            </el-form-item> -->
            <template v-if="changeInfo.is_ybss != '1'">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-row type="flex">
                  <el-col :xs="12" :sm="12" :md="12" :lg="12">
                    <el-form-item
                      label="经度:"
                      prop="cs_dzjd"
                      label-width="200px"
                    >
                      <el-input
                        v-model="changeInfo.cs_dzjd"
                        disabled
                        style="margin-left:10px"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="12">
                    <el-form-item
                      label="纬度:"
                      prop="cs_dzwd"
                      label-width="200px"
                    >
                      <el-input
                        v-model="changeInfo.cs_dzwd"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </template>
            <el-form-item label="是否属于九小场所:" prop="shztdm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-radio-group
                  v-model="changeInfo.isNine"
                  @click.native="clearJxcs(changeInfo.isNine)"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
            <el-form-item label="九小场所:" :prop="JxcsName">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  :disabled="changeInfo.isNine == 2 ? true : false"
                  v-model="changeInfo.jxcs"
                  placeholder=""
                  style="width:100%"
                >
                  <el-option
                    v-for="item in csList"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="执照类型:" prop="zzlxdm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  v-model="changeInfo.zzlxdm"
                  placeholder=""
                  style="width:100%"
                  @change="toogleChange"
                >
                  <el-option
                    v-for="item in zzlxData"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="zTitle + ':'" prop="tyshxydm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model.trim="changeInfo.tyshxydm"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="20" :lg="12">
            <el-form-item
              class="yzzz_zp"
              label="营业执照:"
              :prop="yyzp"
              style="height: 150px;"
            >
              <el-col
                :xs="24"
                :sm="24"
                :md="24"
                :lg="24"
                style="text-align:left;overflow:hidden;"
              >
                <el-upload
                  :disabled="changeInfo.is_zzh == 2 ? true : false"
                  style="width:300px;height:150px"
                  ref="handleupload"
                  action="#"
                  :before-upload="beforeUpload"
                  :http-request="handleUpload"
                  :on-change="handleFileSuccess"
                  list-type="picture-card"
                  :on-preview="PictureCardPreview"
                  :on-remove="Remove"
                  :limit="1"
                  :file-list="list"
                >
                  <div style="line-height: 140px;position:relative">
                    <img src="../../assets/img/addphotoblue.png" alt="" />
                    <div
                      style="position:absolute;top:20px;left:35%;color:#409EFF"
                    >
                      添加执照照片
                    </div>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="hideUpload">
                  <img width="100%" :src="changeInfo.yzzz_zp" />
                </el-dialog>
              </el-col>
            </el-form-item>
            <el-form-item label="门头名称:" prop="mt_mc">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.mt_mc"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="门头照片:" prop="cs_xp">
              <el-col
                :xs="24"
                :sm="24"
                :md="24"
                :lg="24"
                style="text-align:left;overflow:hidden;"
              >
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :http-request="uploadAvatar"
                  :before-upload="beforeAvatarUpload"
                  :file-list="mt_list"
                  :on-change="handleFileSuccess1"
                  :class="{ hide: mt_list.length >= 1 }"
                >
                  <div style="line-height: 140px;position:relative">
                    <img src="../../assets/img/addphotoblue.png" alt="" />
                    <div
                      style="position:absolute;top:20px;left:35%;color:#409EFF"
                    >
                      添加门头照片
                    </div>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="cs_xp_visible">
                  <img width="100%" :src="changeInfo.cs_xp" alt="" />
                </el-dialog>
              </el-col>
            </el-form-item>
            <el-form-item label="娱乐场所类型:" prop="ylcslb">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-select
                  v-model="changeInfo.ylcslb"
                  placeholder=""
                  style="width:100%"
                >
                  <el-option
                    v-for="item in ylcslbData"
                    :key="item.code"
                    :label="item.title"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
                <!-- 娱乐 4 => {默认}  典当7 -->
                <!-- 4 => 娱乐场所类型 - 下拉选框 -->
              </el-col>
            </el-form-item>
            <el-form-item label="开业日期:" prop="kyrq">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-date-picker
                  v-model="changeInfo.kyrq"
                  type="date"
                  placeholder="选择日期"
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="备案编号:" prop="babh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.babh"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="娱乐场所备案证号:" prop="thjyxkz">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.thjyxkz"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="娱乐场所备案机构:" prop="xkzfzjg">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.xkzfzjg"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="场所负责人:" prop="csfzr_xm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.csfzr_xm"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="场所负责人证件号码:" prop="csfzr_sfzhm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.csfzr_sfzhm"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="场所负责人联系电话:" prop="csfzr_lxdh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.csfzr_lxdh"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="法定代表人:" prop="fddbr_xm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.fddbr_xm"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="法定代表人证件号码:" prop="fddbr_zhm">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.fddbr_zhm"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="法定代表人电话:" prop="fddbr_lxdh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.fddbr_lxdh"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="治安负责人:" prop="zafzr">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.zafzr"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="治安负责人证件号:" prop="zafzr_zjh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.zafzr_zjh"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="治安负责人联系电话:" prop="zafzr_lxdh">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-input v-model="changeInfo.zafzr_lxdh"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-form>
        <!-- 场所标准地址弹窗(西安用户) -->
        <el-dialog
          class="areaform"
          title="请选择场所标准地址"
          :visible.sync="pgsVisible"
          @close="reset"
        >
          <div>
            <el-row>
              <el-form
                :model="areaform"
                ref="areaform"
                label-width="120px"
                :rules="arearules"
              >
                <el-row style="height:57px">
                  <el-col :span="6">
                    <el-form-item label="行政区划" prop="xzqh">
                      <el-col :span="24">
                        <el-select
                          style="width:100%"
                          v-model.trim="areaform.xzqh"
                          placeholder=""
                          @change="handleMap"
                          filterable
                          remote
                        >
                          <el-option
                            v-for="item in xzqhList"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="街路巷" prop="jlx">
                      <el-col :span="24">
                        <el-select
                          style="width:100%"
                          v-model.trim="areaform.jlx"
                          placeholder=""
                          filterable
                          remote
                          v-loadmore="more"
                          :remote-method="remoteMethod"
                          reserve-keyword
                          @change="Pgs"
                        >
                          <el-option
                            v-for="(item, index) in jlxList"
                            :key="index"
                            :label="`${item.jlxmc}-${item.dwmc}`"
                            :value="`${item.jlxdm}-${item.dwmc}`"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="详细地址" prop="area">
                      <el-col :span="24">
                        <el-autocomplete
                          ref="autocomplete"
                          style="width:100%"
                          v-model.trim="areaform.area"
                          :fetch-suggestions="querySearchAsync"
                          @change="querySearchAsync"
                          :trigger-on-focus="true"
                          placeholder=""
                          @select="handleSelect"
                          @input="handleTo"
                          @blur="handleBlur"
                          v-scrollLoad="more1"
                          value-key="dzqc"
                        >
                        </el-autocomplete>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div style="color:#FE5C83;padding:0 30px 10px 30px">
                    注：涉及到多间房屋的营业场所地址可以选择到大门牌号;选项中没有对应地址的请联系辖区派出所;增加地址后再重新填报提交信息
                  </div>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <div
                    style="text-align:center;font-size:18px;line-height:60px;color:#000;font-weight:bold"
                  >
                    房屋基本信息
                  </div>
                  <el-col :span="6">
                    <el-form-item label="房屋类别" prop="hi_fwlb">
                      <el-col>
                        <el-select
                          v-model="areaform.hi_fwlb"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in fwlbData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="房屋面积" prop="hi_fwmj">
                      <el-col>
                        <el-input v-model="areaform.hi_fwmj"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="房屋性质" prop="hi_fwxz">
                      <el-col>
                        <el-select
                          v-model="areaform.hi_fwxz"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in fwxzData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="房屋间数" prop="hi_fwjs">
                      <el-col>
                        <el-input v-model="areaform.hi_fwjs"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="房屋用途" prop="hi_fwyt">
                      <el-col>
                        <el-select
                          v-model="areaform.hi_fwyt"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in fwytData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="产权证号" prop="hi_cqzh">
                      <el-col>
                        <el-input v-model="areaform.hi_cqzh"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="房屋现状" prop="hi_fwzt">
                      <el-col>
                        <el-select
                          v-model="areaform.hi_fwzt"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in fwztData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="房屋结构" prop="hi_fwjg">
                      <el-col>
                        <el-select
                          v-model="areaform.hi_fwjg"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in fwjgData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-form-item label="是否出租" prop="hi_sfcz">
                    <el-col>
                      <el-radio-group v-model="areaform.hi_sfcz">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="是否注销" prop="hi_sfzx">
                    <el-col>
                      <el-radio-group v-model="areaform.hi_sfzx">
                        <el-radio :label="0">正常</el-radio>
                        <el-radio :label="1">注销</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="房主/托管人" prop="fz">
                    <el-col>
                      <el-checkbox-group v-model="fz">
                        <el-checkbox
                          v-for="city in cities"
                          :label="city.rolename"
                          :key="city.roleid"
                          >{{ city.rolename }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                  </el-form-item>
                </el-row>
                <el-divider></el-divider>
                <el-row v-show="roomVisible ? true : false">
                  <div
                    style="text-align:center;font-size:18px;line-height:60px;color:#000;font-weight:bold"
                  >
                    房主信息
                  </div>
                  <div style="height:62px">
                    <el-col :span="6">
                      <el-form-item
                        label="证件类型"
                        :prop="roomVisible == false ? '' : 'hi_fz_zjlx'"
                      >
                        <!-- :prop="roomVisible == false ? '' : 'hi_fz_zjlx'"  :prop="hi_fz_zjlx" -->
                        <el-col>
                          <el-select
                            v-model="areaform.hi_fz_zjlx"
                            placeholder=""
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in certypeData"
                              :key="item.code"
                              :label="item.title"
                              :value="item.code"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="证件号码"
                        :prop="roomVisible == false ? '' : 'hi_fz_zjhm'"
                      >
                        <el-col>
                          <el-input v-model="areaform.hi_fz_zjhm"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="房主姓名"
                        :prop="roomVisible == false ? '' : 'hi_fz_xm'"
                      >
                        <el-col>
                          <el-input v-model="areaform.hi_fz_xm"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        label="联系方式"
                        :prop="roomVisible == false ? '' : 'hi_fz_lxdh'"
                      >
                        <el-col>
                          <el-input v-model="areaform.hi_fz_lxdh"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </div>
                  <el-divider></el-divider>
                </el-row>

                <el-row v-show="tgrVisible ? true : false">
                  <div
                    style="text-align:center;font-size:18px;line-height:60px;color:#000;font-weight:bold"
                  >
                    托管人信息
                  </div>
                  <el-col :span="6">
                    <el-form-item
                      label="证件类型"
                      :prop="tgrVisible == false ? '' : 'hi_tgr_zjlx'"
                    >
                      <el-col>
                        <el-select
                          v-model="areaform.hi_tgr_zjlx"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in certypeData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      label="与房主关系"
                      :prop="tgrVisible == false ? '' : 'hi_tgr_yfzgx'"
                    >
                      <el-col>
                        <el-select
                          v-model="areaform.hi_tgr_yfzgx"
                          placeholder=""
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in yfzgxData"
                            :key="item.code"
                            :label="item.title"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="证件号码"
                      :prop="tgrVisible == false ? '' : 'hi_tgr_zjhm'"
                    >
                      <el-col>
                        <el-input v-model="areaform.hi_tgr_zjhm"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="托管人姓名"
                      :prop="tgrVisible == false ? '' : 'hi_tgr_xm'"
                    >
                      <el-col>
                        <el-input v-model="areaform.hi_tgr_xm"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label="联系方式"
                      :prop="tgrVisible == false ? '' : 'hi_tgr_lxdh'"
                    >
                      <el-col>
                        <el-input v-model="areaform.hi_tgr_lxdh"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-row>
          </div>
          <div style="text-align:center">
            <el-button type="primary" size="default" @click="sub('areaform')"
              >确认</el-button
            >
          </div>
        </el-dialog>
        <!--陕西省非西安用户 , 地图选址 -->
        <Map
          v-if="map"
          ref="map"
          :map.sync="map"
          :zagldwbm="changeInfo.zagldwbm"
          :mapObj="changeInfo.mapObj"
          @close="$refs.map.close()"
          @updateLocation="updateLocation"
        />
      </el-row>
      <el-row type="flex" justify="center" style="margin-top: 54px;">
        <el-button type="info" @click="goBack">返回</el-button>
        <el-button class="change" type="primary" @click="submit('changeInfo')"
          >确认</el-button
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import * as user from '@/api/user'
import { getzagldw } from '@/api/day_work'
import {
  regular,
  CheckLicense,
  CheckSocialCreditCode,
  CheckOrganization,
  CheckZongjiao,
  dzqc
} from '@/utils/validate'

import Map from './aliMap'

let Geocoder
const TIME_COUNT = 30 //倒计时时间
export default {
  data() {
    return {
      randomSuffix: Date.now(), // Generating a unique suffix
      readonly: true,
      ylcslbInfo: [],
      codeVisible: false,
      timer: null, //计时器
      code: '', //验证码
      count: '', //倒计时
      show: true, //控制按钮
      infoCode: '',
      updateData: false,
      place_dzmc: '',
      hi_jlxbm: '',
      oldAddress: '',
      state: 'update',
      mapVisible: false,
      marker: {
        position: [108.949807, 34.267378],
        visible: true,
        draggable: false
      },
      center: [108.949807, 34.267378],
      events: {
        init: o => {
          o.getCity(result => {
            console.log(result)
          })
        },
        click: e => {
          let { lng, lat } = e.lnglat
          this.changeInfo.cs_dzjd = lng
          this.changeInfo.cs_dzwd = lat
          this.marker = {
            position: [e.lnglat.lng, e.lnglat.lat],
            visible: true,
            draggable: false
          }
          Geocoder.getAddress(
            [e.lnglat.lng, e.lnglat.lat],
            (status, result) => {
              //根据坐标获取位置

              if (status === 'complete' && result.info === 'OK') {
                if (result && result.regeocode) {
                  console.log(result.regeocode)
                  this.changeInfo.cs_dzmc = result.regeocode.formattedAddress
                  this.changeInfo.cs_xzqhdm =
                    result.regeocode.addressComponent.adcode
                }
              }
            }
          )
        }
      },
      // 当前地图需要的拓展插件需在该内容下放置  Geocoder为通过坐标获取地址信息
      plugin: [
        {
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 100, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
          extensions: 'all',
          pName: 'Geocoder',
          events: {
            init(o) {
              Geocoder = o
            }
          }
        }
      ],
      mapObj: {},
      sousuoName: '',
      areaList: [],
      list: [],
      mt_list: [],
      picList: [],
      imagetype: 'public',
      hideUpload: false,
      imgQuality: 0.4,
      cs_xp_visible: false,
      changeInfo: {
        is_ybss: 1,
        cs_xp: '',
        mt_mc: '',
        hi_content: '',
        username: '',
        infoCode: '',
        userpw: '',
        cs_jyztdm: '',
        csmc: '',
        cs_dmsn: '',
        cs_lxdh: '',
        jymj: '',
        hdxfzrs: '',
        bxsl: '',
        xfdj: '',
        // dwxz: '',
        dwlb: '',
        zagldwbm: [],
        pgs: '',
        cs_dzjd: '',
        cs_dzwd: '',
        shztdm: '',
        jxcs: '',
        zzlxdm: '01',
        tyshxydm: '',
        yzzz_zp: '',
        ylcslb: '',
        kyrq: '',
        babh: '',
        thjyxkz: '',
        xkzfzjg: '',
        csfzr_xm: '',
        csfzr_sfzhm: '',
        csfzr_lxdh: '',
        fddbr_xm: '',
        fddbr_zhm: '',
        fddbr_lxdh: '',
        zafzr: '',
        zafzr_zjh: '',
        zafzr_lxdh: '',
        zcdz: '',
        cs_dzmc: '',
        csfzr_xjzd: '',
        fddbr_zjzpfm: '',
        fddbr_zjzpzm: '',
        // cs_mjpfm: '',
        cs_xzqhdm: '',
        isNine: 2,
        is_zzh: 1,
        area: '',
        jlx: '',
        xzqh: '',
        hi_sfcz: 1,
        hi_sfzx: 0,
        hi_fwlb: '',
        hi_fwxz: '',
        hi_fwyt: '',
        hi_fwzt: '',
        hi_fwmj: '',
        hi_cqzh: '',
        hi_fwjs: '',
        hi_fwjg: '',
        hi_fz_zjlx: '',
        hi_fz_zjhm: '',
        hi_fz_xm: '',
        hi_fz_lxdh: '',
        hi_tgr_zjlx: '',
        hi_tgr_zjhm: '',
        hi_tgr_xm: '',
        hi_tgr_lxdh: '',
        hi_tgr_yfzgx: ''
        // bwfzr_xm: '',
        // bwry_sl: '',
        // bwbm_lxdh: ''
      },
      pno: 1,
      xzqh2List: [],
      status: false,
      // xzqhList: [],
      xzqh: '',
      xzqhdm: '',
      dialog_input: '',
      roadVisible: false,
      jlxList: [],
      jlx: '',
      jlxdm: '',
      jlxmc: '',
      pgsVisible: false,
      pgsList: [],
      area: '',
      pno1: 1,
      pgisdzqc: '',
      csList: [],
      jyztData: [],
      xfdjData: [],
      dwxzData: [],
      dwlbData: [],
      zzlxData: [],
      zTitle: '社会统一信用代码',
      ylcslbData: [],
      fwlbData: [],
      fwxzData: [],
      fwytData: [],
      fwztData: [],
      fwjgData: [],
      certypeData: [],
      yfzgxData: [],
      cs_jyztdm: '',
      JxcsName: 'jxcs',
      arr: 'tyshxydm',
      yyzp: 'yzzz_zp',
      hi_fz_zjlx: 'hi_fz_zjlx',
      dialogState: false,
      areaform: {
        hi_content: '',
        area: '',
        jlx: '',
        xzqh: '',
        hi_sfcz: 1,
        hi_sfzx: 0,
        hi_fwlb: '',
        hi_fwxz: '',
        hi_fwyt: '',
        hi_fwzt: '',
        hi_fwmj: '',
        hi_cqzh: '',
        hi_fwjs: '',
        hi_fwjg: '',
        hi_fz_zjlx: '',
        hi_fz_zjhm: '',
        hi_fz_xm: '',
        hi_fz_lxdh: '',
        hi_tgr_zjlx: '',
        hi_tgr_zjhm: '',
        hi_tgr_xm: '',
        hi_tgr_lxdh: '',
        hi_tgr_yfzgx: ''
      },
      roomVisible: true,
      tgrVisible: true,
      cities: [
        { roleid: 1, rolename: '房主' },
        { roleid: 2, rolename: '托管人' }
      ],
      xzqhList: [],
      fz: ['房主', '托管人'],
      arearules: {
        area: [
          { required: true, message: '请选择详细地址', trigger: 'change' },
          {
            validator: dzqc
          }
        ],
        jlx: [{ required: true, message: '请选择街道巷', trigger: 'change' }],
        xzqh: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        hi_fwlb: [
          { required: true, message: '请选择房屋类别', trigger: 'change' }
        ],
        hi_fwxz: [
          { required: true, message: '请选择房屋性质', trigger: 'change' }
        ],
        hi_fwyt: [
          { required: true, message: '请选择房屋用途', trigger: 'change' }
        ],
        hi_fwzt: [
          { required: true, message: '请选择房屋现状', trigger: 'change' }
        ],
        hi_fwmj: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('房屋面积必须为数字'))
                } else if (/^[0-9]{1,5}$/.test(value) == false) {
                  callback(new Error('房屋面积长度不得超过5'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],
        hi_fwjs: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('房屋间数必须为数字'))
                } else if (/^[0-9]{1,4}$/.test(value) == false) {
                  callback(new Error('房屋间数长度不得超过4'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],
        hi_cqzh: [
          {
            validator: (rule, value, callback) => {
              if (value != '') {
                if (
                  /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false
                ) {
                  callback(new Error('产权证号必须为数字'))
                } else if (/^[0-9]{1,20}$/.test(value) == false) {
                  callback(new Error('产权证号长度不得超过20'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ],

        hi_fz_zjlx: [
          { required: true, message: '请选择房主证件类型', trigger: 'change' }
        ],

        hi_fz_zjhm: [
          { required: true, message: '请输入房主证件号码', trigger: 'blur' },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的房主证件号码',
            trigger: 'blur'
          }
        ],
        hi_fz_xm: [
          { required: true, message: '请输入房主姓名', trigger: 'blur' },
          {
            max: 10,
            message: '房主姓名长度不得超过10',
            trigger: 'blur'
          }
        ],
        hi_fz_lxdh: [
          { required: true, message: '请输入房主联系电话', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的房主联系电话',
            trigger: 'blur'
          }
        ],
        hi_tgr_zjlx: [
          { required: true, message: '请选择托管人证件类型', trigger: 'change' }
        ],
        hi_tgr_zjhm: [
          {
            required: true,
            message: '请输入托管人证件号码',
            trigger: 'change'
          },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的托管人证件号码',
            trigger: 'blur'
          }
        ],
        hi_tgr_xm: [
          { required: true, message: '请输入托管人姓名', trigger: 'blur' },
          {
            max: 10,
            message: '托管人姓名长度不得超过10',
            trigger: 'blur'
          }
        ],
        hi_tgr_lxdh: [
          { required: true, message: '请输入托管人联系电话', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的托管人联系电话',
            trigger: 'blur'
          }
        ],
        hi_tgr_yfzgx: [
          {
            required: true,
            message: '请选择托管人与房主关系',
            trigger: 'change'
          }
        ]
      },
      rules: {
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        ylcslb: [
          { required: true, message: '请选娱乐场所类别', trigger: 'change' }
        ],
        infoCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        userpw: [
          {
            required: true,
            validator: (rule, value, callback) => {
              //必须包含⼤⼩写字母、数字、特殊字符长度再8-16位之间
              var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}')
              if (value === '') {
                callback(new Error('请输⼊密码'))
              } else if (value.length < 8 || value.length > 16) {
                callback(new Error('请输⼊8~16位密码'))
              } else if (!regex.test(value)) {
                callback(new Error('密码必须同时包含字母、数字且⾄少8位'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        zagldwbm: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        cs_jyztdm: [
          { required: true, message: '请选择场经营状态', trigger: 'change' }
        ],
        csmc: [
          { required: true, message: '请输入场所名称', trigger: 'blur' },
          {
            max: 40,
            message: '场所名称长度不得超过40',
            trigger: 'blur'
          }
        ],
        cs_dmsn: [
          { required: true, message: '请输入场所编码', trigger: 'blur' }
        ],
        xfdj: [
          { required: true, message: '请选择消防等级', trigger: 'change' }
        ],
        // dwxz: [
        //   { required: true, message: '请选择单位性质', trigger: 'change' }
        // ],
        dwlb: [
          { required: true, message: '请选择单位类别', trigger: 'change' }
        ],
        pgs: [
          { required: true, message: '请选择场所标准地址', trigger: 'change' },
          {
            validator: dzqc,
            message: '场所标准地址最后一位必须为号'
          }
        ],
        cs_dzmc: [
          { required: true, message: '请选择场所地址名称', trigger: 'blur' }
          // {
          //   max: 200,
          //   message: '场所地址名称长度不得超过200',
          //   trigger: 'blur'
          // }
        ],
        cs_dzjd: [{ required: true, message: '请地图选址', trigger: 'blur' }],
        cs_dzwd: [{ required: true, message: '请地图选址', trigger: 'blur' }],
        zzlxdm: [
          { required: true, message: '请选择执照类型', trigger: 'blur' }
        ],
        yzzz_zp: [
          { required: true, message: '请上传营业执照照片', trigger: 'blur' }
        ],
        mt_mc: [{ required: true, message: '请输入门头名称', trigger: 'blur' }],
        cs_xp: [{ required: true, message: '请上传门头照片', trigger: 'blur' }],
        tyshxydm: [
          {
            required: true,
            message: '请输入社会统一信用代码',
            trigger: 'blur'
          },
          {
            message: '请输入正确的社会统一信用代码',
            validator: CheckSocialCreditCode,
            trigger: 'blur'
          }
        ],
        // cs_lxdh: [
        //   { required: true, message: '请输入场所联系电话', trigger: 'blur' },
        //   {
        //     pattern: regular.phone,
        //     message: '请输入正确的场所联系电话',
        //     trigger: 'blur'
        //   }
        // ],
        hylb: [{ required: true, message: '请选择行业类别', trigger: 'blur' }],
        csfzr_xm: [
          { required: true, message: '请输入场所负责人姓名', trigger: 'blur' },
          {
            max: 15,
            message: '场所负责人姓名长度不得超过15',
            trigger: 'blur'
          }
        ],
        csfzr_sfzhm: [
          {
            required: true,
            message: '请输入场所负责人证件号码',
            trigger: 'blur'
          },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的场所负责人证件号码',
            trigger: 'blur'
          }
        ],

        csfzr_lxdh: [
          {
            required: true,
            message: '请输入场所负责人联系电话',
            trigger: 'blur'
          },
          {
            pattern: regular.phone,
            message: '请输入正确的场所负责人联系电话',
            trigger: 'blur'
          }
        ],
        fddbr_xm: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' },
          {
            max: 15,
            message: '法定代表人长度不得超过15',
            trigger: 'blur'
          }
        ],
        fddbr_zhm: [
          {
            required: true,
            message: '请输入法定代表人证件号码',
            trigger: 'blur'
          },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的法定代表人证件号码',
            trigger: 'blur'
          }
        ],
        fddbr_lxdh: [
          { required: true, message: '请输入法定代表人电话', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的法定代表人电话',
            trigger: 'blur'
          }
        ],
        zafzr: [
          { required: true, message: '请输入治安负责人', trigger: 'blur' },
          {
            max: 15,
            message: '治安负责人长度不得超过15',
            trigger: 'blur'
          }
        ],
        zafzr_zjh: [
          {
            required: true,
            message: '请输入治安负责人证件号',
            trigger: 'blur'
          },
          {
            validator: regular.IDCard,
            message: ' 请输入正确的治安负责人证件号',
            trigger: 'blur'
          }
        ],
        zafzr_lxdh: [
          {
            required: true,
            message: '请输入治安负责人联系电话',
            trigger: 'blur'
          },
          {
            pattern: regular.phone,
            message: '请输入正确的治安负责人联系电话',
            trigger: 'blur'
          }
        ],
        jxcs: [
          {
            required: true,
            message: '请选择九小场所',
            trigger: 'change'
          }
        ]
      },
      defaultParams: {
        checkStrictly: false,
        expandTrigger: 'hover',
        label: 'zagldwname',
        value: 'zagldwbm'
      },
      map: false
    }
  },
  components: { Map },
  watch: {
    fz(valArr) {
      if (valArr.length == 0) {
        this.tgrVisible = false

        this.areaform.hi_tgr_zjlx = ''
        this.areaform.hi_tgr_zjhm = ''
        this.areaform.hi_tgr_xm = ''
        this.areaform.hi_tgr_lxdh = ''
        this.areaform.hi_tgr_yfzgx = ''
        this.roomVisible = false
        this.areaform.hi_fz_zjlx = ''
        this.areaform.hi_fz_zjhm = ''
        this.areaform.hi_fz_xm = ''
        this.areaform.hi_fz_lxdh = ''
      }
      this.fz.filter(i => {
        console.log(i)
        if (valArr.length == 2) {
          this.tgrVisible = true
          this.roomVisible = true
        } else if (valArr.length == 1) {
          if (i == '托管人') {
            this.tgrVisible = true
          } else {
            this.tgrVisible = false
            this.areaform.hi_tgr_zjlx = ''
            this.areaform.hi_tgr_zjhm = ''
            this.areaform.hi_tgr_xm = ''
            this.areaform.hi_tgr_lxdh = ''
            this.areaform.hi_tgr_yfzgx = ''
          }
          if (i == '房主') {
            this.roomVisible = true
          } else {
            this.roomVisible = false
            this.areaform.hi_fz_zjlx = ''
            this.areaform.hi_fz_zjhm = ''
            this.areaform.hi_fz_xm = ''
            this.areaform.hi_fz_lxdh = ''
          }
        } else {
          this.tgrVisible = false
          this.areaform.hi_tgr_zjlx = ''
          this.areaform.hi_tgr_zjhm = ''
          this.areaform.hi_tgr_xm = ''
          this.areaform.hi_tgr_lxdh = ''
          this.areaform.hi_tgr_yfzgx = ''
          this.roomVisible = false
          this.areaform.hi_fz_zjlx = ''
          this.areaform.hi_fz_zjhm = ''
          this.areaform.hi_fz_xm = ''
          this.areaform.hi_fz_lxdh = ''
        }
      })
    },
    'changeInfo.is_ybss': {
      handler(val) {
        if (val == 1) {
          console.log('监控:一标三实', val)
          // 如果选择西安
          this.$set(this.rules, 'pgs', [
            {
              required: true,
              message: '请选择场所标准地址',
              trigger: 'change'
            },
            {
              validator: dzqc,
              message: '场所标准地址最后一位必须为号'
            }
          ])
        } else {
          console.log('监控:非西安', val)
          this.$set(this.rules, 'pgs', [
            { required: true, message: '请选择场所标准地址', trigger: 'change' }
          ])
        }
      },
      deep: true
    },
    // 'changeInfo.zagldwbm': {
    //   handler(val) {
    //     if (val[0] == '610100000000') {
    //       console.log('监控:西安', val);
    //       // 如果选择西安
    //       this.$set(this.rules, 'pgs', [
    //         { required: true, message: '请选择场所标准地址', trigger: 'change' },
    //         {
    //           validator: dzqc,
    //           message: '场所标准地址最后一位必须为号'
    //         }
    //       ])
    //     } else {
    //       console.log('监控:非西安', val)
    //       this.$set(this.rules, 'pgs', [
    //         { required: true, message: '请选择场所标准地址', trigger: 'change' }
    //       ])
    //     }
    //   },
    //   deep: true
    // },
    mt_list(val) {
      const urlList = []
      if (!this.mt_list) return
      this.mt_list.forEach(item => {
        urlList.push(item.url)
      })
      this.changeInfo.cs_xp = urlList.join(',')
      console.log('this.mt_list', val)
      console.log('this.changeInfo.cs_xp', this.changeInfo.cs_xp)
    }
  },
  async mounted() {
    // this.$refs['map'].open()
    this.getZzlx()
    this.getzagldw()
    // this.getArea()
    this.getXzqh()
    this.getjyzt()
    this.getxfdj()
    this.getdwxz()
    this.getdwlb()
    this.getjxcs()
    this.getFwlb()
    this.getFwxz()
    this.getFwyt()
    this.getFwzt()
    this.getFwjg()
    this.getZjlx()
    this.getfzgx()
    this.getylcslb()
    if (this.changeInfo.isNine == 2) {
      this.changeInfo.jxcs = ''
      this.JxcsName = ''
    }
    setInterval(function() {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
  methods: {
    handleClick(){
      console.log(111)
      this.readonly = !this.readonly
    },
    handleInput(value) {
      console.log('input', value)
      if (!value) {
        this.readonly = true
      }
    },
    handlePhone() {
      if (
        this.changeInfo.username &&
        this.changeInfo.username.match(/(^1[3|4|5|6|7|8|9][0-9]{9}$)/)
      ) {
        this.codeVisible = true
        this.infoCode = ''
      }
    },
    //发送验证码
    getCode() {
      this.$refs.changeInfo.validateField('username', async errMsg => {
        if (errMsg) {
          console.log('校验失败')
          return
        } else {
          //...
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer) // 清除定时器
                this.timer = null
              }
            }, 1000)
          }
          await user.getCode(this.changeInfo.username)
          this.$message.success('发送成功!')
        }
      })
    },
    isXAChange() {
      this.changeInfo.pgs = ''
      this.changeInfo.cs_dzwd = ''
      this.changeInfo.cs_dzjd = ''
      this.changeInfo.mapObj = null
    },

    goBack() {
      this.$router.back(-1)
    },
    async getXzqh() {
      const res = await user.getXzqh()
      this.xzqhList = res
    },
    async getjyzt() {
      const res = await user.getJyzt()
      this.jyztData = res
    },
    async getxfdj() {
      const res = await user.getXfdj()
      this.xfdjData = res
    },
    async getdwxz() {
      const res = await user.getdwxz()
      this.dwxzData = res
    },
    async getdwlb() {
      const res = await user.getdwlb()
      this.dwlbData = res
    },
    async getzagldw(data) {
      const res = await getzagldw(data)
      // const xiAn = {
      //   zagldwname: '西安市公安局',
      //   zagldwbm: '610100000000'
      // }
      // this.xzqh2List = [xiAn, ...res]
      this.xzqh2List = res
    },
    async getZzlx() {
      const res = await user.getZzlx()
      this.zzlxData = res
    },
    async getylcslb() {
      const res = await user.getylcslb()
      this.ylcslbData = res
    },
    toogleChange(val) {
      this.changeInfo.tyshxydm = ''
      if (val === '01') {
        this.zTitle = '社会统一信用代码'
        this.$refs.changeInfo.clearValidate(['tyshxydm'])
        this.rules.tyshxydm[0] = {
          required: true,
          message: '请输入社会统一信用代码',
          trigger: 'blur'
        }
        this.rules.tyshxydm[1] = {
          message: '请输入正确的统一信用代码',
          validator: CheckSocialCreditCode,
          trigger: 'blur'
        }
      } else if (val === '02') {
        this.zTitle = '工商执照号'
        this.$refs.changeInfo.clearValidate(['tyshxydm'])
        this.rules.tyshxydm[0] = {
          required: true,
          message: '请输入工商执照号',
          trigger: 'blur'
        }
        this.rules.tyshxydm[1] = {
          message: '请输入正确的工商执照号',
          validator: CheckLicense,
          trigger: 'blur'
        }
      } else if (val === '03') {
        this.zTitle = '组织机构代码'
        this.$refs.changeInfo.clearValidate(['tyshxydm'])
        this.rules.tyshxydm[0] = {
          required: true,
          message: '请输入组织机构代码',
          trigger: 'blur'
        }
        this.rules.tyshxydm[1] = {
          validator: CheckOrganization,
          message: '请输入正确的组织机构代码',
          trigger: 'blur'
        }
      } else if (val === '04') {
        this.zTitle = '宗教编码'
        this.$refs.changeInfo.clearValidate(['tyshxydm'])
        this.rules.tyshxydm[0] = {
          required: true,
          message: '请输入宗教编码',
          trigger: 'blur'
        }
        this.rules.tyshxydm[1] = {
          validator: CheckZongjiao,
          message: '请输入正确的宗教编码',
          trigger: 'blur'
        }
      } else if (val === '09') {
        this.zTitle = '非正规单位负责人身份证'
        this.$refs.changeInfo.clearValidate(['tyshxydm'])
        this.rules.tyshxydm[0] = {
          required: true,
          message: '请输入非正规单位负责人身份证',
          trigger: 'blur'
        }
        this.rules.tyshxydm[1] = {
          validator: regular.IDCard,
          message: ' 请输入正确的非正规单位负责人身份证',
          trigger: 'blur'
        }
      }
    },
    async getjxcs() {
      const res = await user.getjxcs()
      this.csList = res
    },
    async getFwlb() {
      const res = await user.getFwlb()
      this.fwlbData = res
    },
    async getFwxz() {
      const res = await user.getFwxz()
      this.fwxzData = res
    },
    async getFwyt() {
      const res = await user.getFwyt()
      this.fwytData = res
    },
    async getFwzt() {
      //房屋现状
      const res = await user.getFwzt()
      this.fwztData = res
    },
    async getFwjg() {
      const res = await user.getFwjg()
      this.fwjgData = res
    },

    async getZjlx() {
      const res = await user.getZjlx()
      this.certypeData = res
    },
    async getfzgx() {
      const res = await user.getfzgx()
      this.yfzgxData = res
    },
    clearJxcs(val) {
      if (val == 1) {
        this.$refs.changeInfo.fields.map(i => {
          if (i.prop === 'jxcs') {
            i.clearValidate()
            this.$refs.changeInfo.clearValidate(['jxcs'])
          }
        })

        this.changeInfo.jxcs = ''
        this.JxcsName = ''
      } else {
        this.JxcsName = 'jxcs'
      }
    },
    async getJlx() {
      const res = await user.getJlx({ xzqh: this.areaform.xzqh, pno: this.pno })
      this.jlxList.push(...res.datas)
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        // setTimeout(async () => {
        const data = await user.getJlx({
          xzqh: this.areaform.xzqh,
          pno: 1,
          prefixtext: query
        })
        console.log(data)
        this.jlxList = data.datas
        // }, 200)
      }
      // else {
      //   this.options = []
      // }
    },
    handleTo() {
      this.pgisdzqc = ''
    },
    handleBlur() {
      if (!this.pgisdzqc) {
        this.areaform.area = ''
      }
    },
    async querySearchAsync(queryString, cb) {
      console.log('queryString', queryString)
      this.pno1 = 1
      if (!this.areaform.jlx) {
        this.jlxdm = ''
        this.pgsList = []
      }
      if (!this.areaform.area) {
        if (!queryString) {
          let List = []
          console.log(this.pgsList)
          this.pgsList.forEach(e => {
            var obj = {}
            obj.value = e.dzqc
            obj.dzdm = e.dzdm
            obj.dzqc = e.dzqc
            obj.pgisdzqc = e.pgisdzqc
            List.push(obj)
          })
          cb(List)
        } else {
          const data = await user.getArea({
            jlx: this.jlxdm,
            pno: 1,
            prefixtext: queryString
          })
          this.pgsList = data.datas
          let List = []
          this.pgsList.forEach(e => {
            var obj = {}
            obj.value = e.dzqc
            obj.dzdm = e.dzdm
            obj.dzqc = e.dzqc
            obj.pgisdzqc = e.pgisdzqc
            List.push(obj)
          })
          cb(List)
          if (this.pgsList.length <= 1) {
            this.status = true
          } else {
            this.status = false
            this.$refs.autocomplete.$refs.input.focus()
          }
        }
      } else {
        const data = await user.getArea({
          jlx: this.jlxdm,
          pno: 1,
          prefixtext: this.areaform.area
        })
        this.pgsList = data.datas
        console.log('pgs', data)
        let List = []
        this.pgsList.forEach(e => {
          var obj = {}
          obj.value = e.dzqc
          obj.dzdm = e.dzdm
          obj.dzqc = e.dzqc
          obj.pgisdzqc = e.pgisdzqc
          List.push(obj)
        })
        console.log('00000', List)
        this.areaform.hi_content = List[0].pgisdzqc
        cb(List)
        if (this.pgsList.length <= 1) {
          this.status = true
        } else {
          this.status = false
          this.$refs.autocomplete.$refs.input.focus()
        }
      }
    },
    handleMap() {
      this.pno = 1
      this.jlxList = []
      this.pgsList = []
      this.getJlx()
      this.areaform.jlx = ''
      this.areaform.area = ''
    },
    handleSelect(item) {
      this.pgisdzqc = item.pgisdzqc
      console.log(this.pgisdzqc)
      this.$refs.autocomplete.$refs.input.focus()
    },
    Pgs(val) {
      this.jlxmc = val.split('-')[1]
      this.jlxdm = val.split('-')[0]
      this.pno1 = 1
      this.pgsList = []
      this.getPgs()
      this.areaform.area = ''
    },
    handlPgs() {
      console.log('点击弹出', this.changeInfo.zagldwbm)
      if (this.changeInfo.is_ybss == 1) {
        this.map = false
        this.pgsVisible = true
        this.getXzqh()
        if (this.areaform.xzqh) {
          this.getJlx()
        }
      } else {
        this.map = true
        this.pgsVisible = false
        this.$nextTick(() => {
          this.$refs['map'].open(this.changeInfo.mapObj)
        })
      }
    },
    async getPgs() {
      const data = await user.getArea({
        jlx: this.jlxdm,
        pno: this.pno1
      })
      console.log(data)
      this.pgsList.push(...data.datas)
    },
    more() {
      console.log('more')
      this.pno++
      this.getJlx()
    },
    async more1() {
      this.pno1++

      const data = await user.getArea({
        jlx: this.jlxdm,
        prefixtext: this.areaform.area,
        pno: this.pno1
      })

      this.pgsList.push(...data.datas)

      this.$refs['autocomplete'].$data.suggestions.push(...data.datas)
    },
    sub() {
      this.$refs.areaform.validate(valid => {
        if (valid) {
          this.dialogState = true
          if (this.pgisdzqc) {
            this.changeInfo.pgs = this.areaform.area
            this.pgsVisible = false
          } else if (this.areaform.area !== this.oldAddress && !this.pgisdzqc) {
            this.areaform.area = ''
            this.pgsVisible = true
            // this.pgisdzqc = this.pgsList[0].pgisdzqc
          } else if (this.areaform.area === this.oldAddress) {
            this.pgsVisible = false
          }
          // // alert(this.pgisdzqc)
          // if (!this.pgisdzqc) {
          //   this.areaform.area = ''
          //   this.changeInfo.pgs = ''
          //   this.pgsVisible = true
          // } else {
          //   this.changeInfo.pgs = this.areaform.area
          //   this.pgsVisible = false
          // }

          // this.changeInfo.pgs = this.areaform.area
          // this.pgisdzqc = this.pgsList[0].pgisdzqc
          this.changeInfo.jlxmc = this.jlxmc
          this.changeInfo.jlxdm = this.jlxdm

          this.changeInfo.hi_content = this.areaform.hi_content

          this.changeInfo.hi_xzqhbm = this.areaform.xzqh
          this.changeInfo.hi_jlx = this.areaform.jlx
          this.changeInfo.hi_dzmc = this.areaform.area
          this.changeInfo.hi_fwlb = this.areaform.hi_fwlb
          this.changeInfo.hi_fwxz = this.areaform.hi_fwxz
          this.changeInfo.hi_fwyt = this.areaform.hi_fwyt
          this.changeInfo.hi_fwzt = this.areaform.hi_fwzt
          this.changeInfo.hi_fwmj = this.areaform.hi_fwmj
          this.changeInfo.hi_fwjs = this.areaform.hi_fwjs
          this.changeInfo.hi_cqzh = this.areaform.hi_cqzh
          this.changeInfo.hi_fwjg = this.areaform.hi_fwjg
          this.changeInfo.hi_sfcz = this.areaform.hi_sfcz
          this.changeInfo.hi_sfzx = this.areaform.hi_sfzx
          this.changeInfo.hi_is_fz = this.roomVisible ? '1' : '0'
          this.changeInfo.hi_is_tgr = this.tgrVisible ? '1' : '0'

          this.changeInfo.hi_fz_zjlx = this.areaform.hi_fz_zjlx
          this.changeInfo.hi_fz_zjhm = this.areaform.hi_fz_zjhm
          this.changeInfo.hi_fz_xm = this.areaform.hi_fz_xm
          this.changeInfo.hi_fz_lxdh = this.areaform.hi_fz_lxdh

          this.changeInfo.hi_tgr_zjlx = this.areaform.hi_tgr_zjlx
          this.changeInfo.hi_tgr_zjhm = this.areaform.hi_tgr_zjhm
          this.changeInfo.hi_tgr_xm = this.areaform.hi_tgr_xm
          this.changeInfo.hi_tgr_lxdh = this.areaform.hi_tgr_lxdh
          this.changeInfo.hi_tgr_yfzgx = this.areaform.hi_tgr_yfzgx
        }
      })
    },
    reset() {
      if (!this.dialogState) {
        this.$refs.areaform.resetFields()
      }
      this.dialogState = false
      this.jlxList = []
      this.pgsList = []
      this.pgsVisible = false
      // this.changeInfo.pgs = ''
      // this.status = false
    },
    async getArea() {
      const { data, status, msg } = await user.getArea()
      if (status === 1) {
        this.areaList = data
      } else {
        this.$message.error(msg)
      }
    },
    changeArea() {
      // 监听值发生变化就关闭它
      this.$refs.cascader.dropDownVisible = false
      let rindex = ''
      if (this.changeInfo.zagldwbm.length === 1) {
        this.changeInfo.zagldwbm = this.changeInfo.zagldwbm[0]
      } else if (this.changeInfo.zagldwbm.length > 1) {
        rindex = this.changeInfo.zagldwbm.length
        this.changeInfo.zagldwbm = this.changeInfo.zagldwbm[rindex - 1]
      }
    },
    async handleUpload(files) {
      const _file = files.file
      let extension = files.file.name.substring(
        files.file.name.lastIndexOf('.') + 1
      )
      if (extension != 'jpg' && extension != 'png' && extension != 'jpeg') {
        this.$message.warning('上传图片格式有误!')
        this.list = []
        this.changeInfo.yzzz_zp = []
      } else if (_file.size > 600 * 1024) {
        console.log('大于400k')
        this.$message.error('图片过大')
        this.list = []
      } else {
        console.log(_file)
        let param = new FormData()
        param.append('image', files.file)
        param.append('imagetype', this.imagetype)
        console.log(param)
        await user.uploadImg(param).then(
          res => {
            console.log(res, 1111111)
            this.changeInfo.yzzz_zp = res.showimg

            this.list.push({ url: res.showimg })
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    PictureCardPreview() {
      this.hideUpload = true
    },
    Remove() {
      this.list = []
      this.changeInfo.yzzz_zp = ''
    },
    dataURItoBlob(dataURI, type) {
      // console.log('dataURI:' + dataURI)
      var binary = atob(dataURI.split(',')[1])
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], { type: type })
    },
    beforeUpload(file) {
      //文件上传之前
      const _this = this
      if (file.size > 400 * 1024) {
        return new Promise(resolve => {
          const reader = new FileReader()
          const image = new Image()
          image.onload = () => {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            const width = image.width * _this.imgQuality
            const height = image.height * _this.imgQuality
            canvas.width = width
            canvas.height = height
            context.clearRect(0, 0, width, height)
            context.drawImage(image, 0, 0, width, height)
            const dataUrl = canvas.toDataURL(file.type)
            const blobData = _this.dataURItoBlob(dataUrl, file.type)

            resolve(blobData)
          }
          reader.onload = e => {
            image.src = e.target.result
          }
          reader.readAsDataURL(file)
          // console.log(reader.readAsDataURL(file))
        })
      }
    },
    async submit(formName) {
      this.changeInfo.jlxmc = this.jlxmc
      const formParamter = {
        user: {
          //账号密码验证码
          mobile: this.changeInfo.username,
          password: this.changeInfo.userpw,
          sms_code: this.changeInfo.infoCode
        },
        place_info: {
          //常规
          zagldwbm: this.changeInfo.zagldwbm[
            this.changeInfo.zagldwbm.length - 1
          ],
          is_ybss: this.changeInfo.is_ybss,
          dwcode: this.changeInfo.zagldwbm[this.changeInfo.zagldwbm.length - 1],
          cs_dzmc: this.changeInfo.pgs, //dzqc
          cs_dzjd: this.changeInfo.cs_dzjd || null, //地图选址-经度
          cs_dzwd: this.changeInfo.cs_dzwd || null, //地图选址-纬度
          cs_jyztdm: this.changeInfo.cs_jyztdm,
          csmc: this.changeInfo.csmc,
          cs_dmsn: this.changeInfo.cs_dmsn,
          cs_lxdh: this.changeInfo.cs_lxdh,
          cs_mjpfm: this.changeInfo.jymj,
          hdxfz_sl: this.changeInfo.hdxfzrs,
          bx_fwjs: this.changeInfo.bxsl,
          xfdj: this.changeInfo.xfdj,
          // dwxz: this.changeInfo.dwxz,
          dwlb: this.changeInfo.dwlb,
          jxcs: this.changeInfo.jxcs,
          zzlxdm: this.changeInfo.zzlxdm,
          tyshxydm: this.changeInfo.tyshxydm, // ? 非正规单位负责人身份证
          zz_xp: this.changeInfo.yzzz_zp, //执照照片
          mt_mc: this.changeInfo.mt_mc,
          cs_xp: this.changeInfo.cs_xp,
          cs_kyrq: this.changeInfo.kyrq,
          thbabh: this.changeInfo.babh,
          hyjyxkzhm: this.changeInfo.thjyxkz,
          hyjyxkzfzjgmc: this.changeInfo.xkzfzjg,
          csfzr_xm: this.changeInfo.csfzr_xm,
          csfzr_sfzhm: this.changeInfo.csfzr_sfzhm,
          csfzr_lxdh: this.changeInfo.csfzr_lxdh,
          fddbr_xm: this.changeInfo.fddbr_xm,
          fddbr_zhm: this.changeInfo.fddbr_zhm,
          fddbr_lxdh: this.changeInfo.fddbr_lxdh,
          zafzr: this.changeInfo.zafzr,
          zafzr_zjh: this.changeInfo.zafzr_zjh,
          zafzr_lxdh: this.changeInfo.zafzr_lxdh,
          ylcslxdm: this.changeInfo.ylcslb
        },
        // zcdz: this.changeInfo.zcdz,
        // yzzz_zp: this.changeInfo.yzzz_zp,
        // fddbr_zjzpfm: this.changeInfo.fddbr_zjzpfm,
        // fddbr_zjzpzm: this.changeInfo.fddbr_zjzpzm,
        // cs_xzqhdm: this.changeInfo.cs_xzqhdm,
        // cs_dzmc: this.pgisdzqc,
        house_info: {
          // 场所标准地址
          hi_content:
            this.changeInfo.is_ybss === 1 ? this.changeInfo.hi_content : '', //pgisdzqc
          hi_dwmc:
            this.changeInfo.is_ybss === 1
              ? this.changeInfo.jlxmc
              : this.changeInfo.hi_dwmc,

          hi_xzqhbm: this.changeInfo.hi_xzqhbm,
          // hi_jlxmc: this.changeInfo.hi_jlx,
          hi_dzmc: this.changeInfo.pgs, //dzqc
          hi_fwlb: this.changeInfo.hi_fwlb,
          hi_fwxz: this.changeInfo.hi_fwxz,
          hi_fwyt: this.changeInfo.hi_fwyt,
          hi_fwzt: this.changeInfo.hi_fwzt,
          hi_fwmj: this.changeInfo.hi_fwmj,
          hi_fwjs: this.changeInfo.hi_fwjs,
          hi_cqzh: this.changeInfo.hi_cqzh,
          hi_fwjg: this.changeInfo.hi_fwjg,
          hi_sfcz: this.changeInfo.hi_sfcz,
          hi_sfzx: this.changeInfo.hi_sfzx,
          hi_is_fz: this.changeInfo.hi_is_fz,
          hi_is_tgr: this.changeInfo.hi_is_tgr,

          hi_fz_zjlx: this.changeInfo.hi_fz_zjlx,
          hi_fz_zjhm: this.changeInfo.hi_fz_zjhm,
          hi_fz_xm: this.changeInfo.hi_fz_xm,
          hi_fz_lxdh: this.changeInfo.hi_fz_lxdh,

          hi_tgr_zjlx: this.changeInfo.hi_tgr_zjlx,
          hi_tgr_zjhm: this.changeInfo.hi_tgr_zjhm,
          hi_tgr_xm: this.changeInfo.hi_tgr_xm,
          hi_tgr_lxdh: this.changeInfo.hi_tgr_lxdh,
          hi_tgr_yfzgx: this.changeInfo.hi_tgr_yfzgx
        }
      }
      // console.log(formParamter);
      this.$refs[formName].validate(async valid => {
        if (valid) {
          await user.logon(formParamter)

          this.$message.success('注册成功,请登录!')
          this.$router.push({
            path: '/login'
          })
        }
      })
    },

    updateLocation(
      orgAddr,
      lon,
      lat,
      province,
      city,
      district,
      name,
      zagldwbm,
      hi_dwmc
    ) {
      this.changeInfo.mapObj = {
        address: orgAddr,
        province: province,
        city: city,
        latitude: lat, // 纬度
        longitude: lon, // 经度
        district: district,
        name: name,
        zagldwbm: zagldwbm
      }
      this.$set(this.changeInfo, 'pgs', this.changeInfo.mapObj.address)
      this.changeInfo.sousuoName = name
      this.changeInfo.cs_dzjd = lon
      this.changeInfo.cs_dzwd = lat
      this.jlxmc = hi_dwmc
      this.changeInfo.hi_dwmc = hi_dwmc
      console.log('点击地图选点后单位名称', this.jlxmc)
      // this.changeInfo.zagldwbm = this.changeInfo.mapObj.address
      console.log('mapObj', this.changeInfo.mapObj)
    },
    // 图片校验取消
    handleFileSuccess() {
      this.$refs.changeInfo.clearValidate('yzzz_zp') //清除图片校验文字
    },

    //====================================================
    uploadAvatar(files) {
      const _file = files.file
      let extension = files.file.name.substring(
        files.file.name.lastIndexOf('.') + 1
      )
      if (extension != 'jpg' && extension != 'png' && extension != 'jpeg') {
        this.$message.warning('上传图片格式有误!')
        this.mt_list = []
        this.changeInfo.cs_xp = []
      } else if (_file.size > 600 * 1024) {
        console.log('大于400k')
        this.$message.error('图片过大')
        this.mt_list = []
      } else {
        console.log(_file)
        let param = new FormData()
        param.append('image', files.file)
        param.append('imagetype', this.imagetype)
        console.log(param)
        user.uploadImg(param).then(
          res => {
            console.log(res, 1111111)
            // this.changeInfo.cs_xp = res.showimg

            this.mt_list.push({ url: res.showimg })
            this.emptyUpload()
          },
          err => {
            console.log(err)
            this.emptyUpload()
          }
        )
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG或png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return (isJPG || isPng) && isLt2M
    },
    handleRemove(file) {
      for (const i in this.mt_list) {
        if (this.mt_list[i].url === file.url) {
          this.mt_list.splice(i, 1)
        }
      }
    },
    handlePictureCardPreview(file) {
      this.changeInfo.cs_xp = file.url
      this.cs_xp_visible = true
    },
    /**
     * 清空上传组件
     */
    emptyUpload() {
      const mainImg = this.$refs.upload
      if (mainImg) {
        if (mainImg.length) {
          mainImg.forEach(item => {
            item.clearFiles()
          })
        } else {
          this.$refs.upload.clearFiles()
        }
      }
    },
    // 图片校验取消
    handleFileSuccess1() {
      this.$refs.changeInfo.clearValidate('cs_xp') //清除图片校验文字
    }
    //====================================================
  }
}
</script>

<style lang="less" scoped>
.hide {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}

h4,
h5,
p,
div {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hotel-main-title {
  text-align: center;
}

.title-name {
  font-weight: 500;
  font-size: 24px;
  color: #6345d5;
}

.main {
  padding: 20px;

  .zzdw {
    margin-right: 12px;
    font-size: 12px;
    color: #6345d5;
    font-style: normal;
  }

  .title_a {
    margin-left: 5px;
    font-size: 18px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #6345d5;
    line-height: 36px;
  }

  .code_div {
    position: relative;
  }

  // 标准场所按钮
  /deep/ .el-input-group__prepend {
    background-color: #6345d5;
    color: #fff;
    font-size: 12px;
    padding: 0 10px;
  }

  /deep/ .code {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    height: 42px;
    top: 0x;
    right: -9px;
    font-size: 12px;
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    /*缩小后文字居左*/
    -webkit-transform: scale(0.7);
    /*关键*/
    transform: scale(0.6);
    background: #6345d5;
    border-radius: 0px 6px 6px 0px;
  }

  /deep/ .yzzz_zp {
    .el-form-item__content {
      width: 100%;
    }
  }

  .code-btn {
    width: 100px;
    height: 26px;
    position: absolute;
    top: 8px;
    right: 15px;
    z-index: 222;
    color: #ef8466;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: transparent;
    cursor: pointer;
  }

  .getcode:hover {
    color: #409eff;

    background-color: #fff;
  }

  /deep/ .el-input__inner {
    height: 35px;
    line-height: 35px;
  }

  /deep/ .changeInfo .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .areaform .el-form-item {
    margin-bottom: 15px;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    color: #303133;
  }

  /deep/ .el-upload--picture-card {
    // background: url('../../assets/img/addphotoblue.png') no-repeat;
    // background-size: 100%;
    width: 300px;
    height: 150px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 300px;
    height: 150px;
  }

  /deep/ .el-upload-list__item {
    transition: none !important;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 300px;
    height: 150px;
  }

  /deep/ .is-disabled + .el-upload--picture-card {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }

  /deep/ .areaform {
    .el-form {
      text-align: left;
    }

    .el-dialog {
      margin-top: 30px !important;
      width: 90% !important;

      .el-dialog__header {
        text-align: center;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #000;
        // color: #303133;
        text-align: center;
        font-weight: bold;
      }
    }
  }

  /deep/ .el-dialog {
    text-align: center;
  }

  .item {
    height: 60px;
    line-height: 60px;
    width: 100%;
  }

  .button-content {
    margin-top: 30px;
    min-width: 560px !important;
  }
}
</style>
